import 'core-js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import './styles/styles.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { App as ARDentalForHealth } from './components/Arkansas/DentalForHealth/App';
import { App as HIDentalForHealth } from './components/Hawaii/DentalForHealth/App';
import { App as FLDentalForHealth } from './components/Florida/DentalForHealth/App';
import { FourOhFour } from './components/shared/Components/FourOhFour';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

if (window.location.href.indexOf("/ar/dentalforhealth/") > -1) {
  setInterval(function() {
        window.top.postMessage(document.body.scrollHeight, "https://www.arkansasbluecross.com");
    }, 500); 
}

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Switch>
      <Route path="/ar/dentalforhealth/" component={ARDentalForHealth} />
      <Route path="/hi/dentalforhealth" component={HIDentalForHealth} />
      <Route path="/fl/dentalforhealth" component={FLDentalForHealth} />
      <Route path="*" component={FourOhFour} />
    </Switch>
  </BrowserRouter>,
  rootElement);
